import { useCallback, useEffect, useMemo, useRef } from 'react';

import { ResourceStatusEnum } from '@/types/schema';

import { QuizEditorDetailsFragment } from '../../graphql/fragments/generated/QuizEditorContent';
import { useQuizEditorDetailsQuery } from '../../graphql/queries/generated/quizEditorDetails';

interface Params {
  contentId: string;
}

const useQuizEditorData = ({ contentId }: Params) => {
  const validQuizRef = useRef<QuizEditorDetailsFragment | undefined>();
  const [{ fetching, error, data }, refetch] = useQuizEditorDetailsQuery({
    variables: { contentId, versionStatus: ResourceStatusEnum.Draft },
    requestPolicy: 'network-only',
  });

  const quiz = useMemo(() => {
    if (data?.content) {
      validQuizRef.current = data.content as QuizEditorDetailsFragment;
    }
    return validQuizRef.current;
  }, [data?.content]);

  const refetchQuiz = useCallback(() => {
    refetch({ requestPolicy: 'cache-and-network' });
  }, [refetch]);

  useEffect(() => {
    if (!fetching) {
      refetchQuiz();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fetching, error, quiz, refetchQuiz };
};

export default useQuizEditorData;
